import { render, staticRenderFns } from "./AdditionalAddress.vue?vue&type=template&id=53fb55b2&"
import script from "./AdditionalAddress.vue?vue&type=script&lang=js&"
export * from "./AdditionalAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports